<template>
  <div id="app">
    <transition name="slide-fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  // 公共meta
  metaInfo() {
    return {
      // 默认title
      title: this.$route.meta.title ? this.$route.meta.title : 'online-load'
    }
  },
  created() {
    this.$toast.success2 = (option = '提交成功') => {
      this.$toast.success(
        Object.assign(
          {
            className: 'toast-inleelen',
            overlay: true,
            closeOnClick: true
          },
          typeof option === 'string' ? { message: option } : option,
          { icon: 'success2' }
        )
      )
    }
    this.$toast.fail2 = (option = '提交失败') => {
      this.$toast.fail(
        Object.assign(
          {
            className: 'toast-inleelen',
            overlay: true,
            closeOnClick: true
          },
          typeof option === 'string' ? { message: option } : option,
          { icon: 'fail2' }
        )
      )
    }
  }
}
</script>

<style lang="less">
@import './assets/style/base.less';
// 路由过度
.slide-fade {
  &-enter {
    opacity: 0;
    transform: translateX(10px);
  }
  &-leave-to {
    opacity: 0;
    transform: translateX(-10px);
  }
  &-enter-active,
  &-leave-active {
    transition: all 0.2s ease;
  }
}
</style>
